if (!customElements.get('multicolumn-slider')) {
  customElements.define(
    'multicolumn-slider',
    class MulticolumnSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.multicolumn__items',
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.sectionId ? document.querySelector(`.section-${this.sectionId}`) : null;
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.variableWidth = this.dataset.variableWidth === 'true';
        this.columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 4;
        this.columnsTablet = parseInt(this.dataset.columnsTablet, 10) || 2;

this.sliderInstance = null;
        this._focusinHandlers = [];

        if (!this.enableSlider || !this.sliderWrapper) return;

        this._onMatchMobile = () => this.init();
        this._onUnmatchMobile = () => this.init();
        document.addEventListener('matchMobile', this._onMatchMobile);
        document.addEventListener('unmatchMobile', this._onUnmatchMobile);

        this.init();
      }

      disconnectedCallback() {
        if (this._onMatchMobile) {
          document.removeEventListener('matchMobile', this._onMatchMobile);
          document.removeEventListener('unmatchMobile', this._onUnmatchMobile);
        }
        if (this._onBlockSelect) {
          document.removeEventListener('shopify:block:select', this._onBlockSelect);
        }
        this._clearFocusinHandlers();
        this.destroySlider();
      }

      _clearFocusinHandlers() {
        this._focusinHandlers?.forEach(({ element, handler }) => {
          element.removeEventListener('focusin', handler);
        });
        this._focusinHandlers = [];
      }

      init() {
        if (typeof FoxTheme === 'undefined' || FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        const gapContainer = this.closest('.section__content') || this.sliderWrapper;
        const columnGap = FoxTheme.utils.getGridColumnGap(gapContainer);

        const sliderOptions = {
          slidesPerView: this.variableWidth ? 'auto' : Math.min(this.columnsTablet, this.sliderWrapper.children.length),
          spaceBetween: columnGap.tablet,
          navigation: {
            nextEl: this.section?.querySelector(this.selectors.nextEl),
            prevEl: this.section?.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            1024: {
              slidesPerView: this.variableWidth ? 'auto' : Math.min(this.columnsDesktop, this.sliderWrapper.children.length),
              spaceBetween: columnGap.desktop,
            },
          },
          loop: true,
          threshold: 2,
        };

        if (!this.sliderInstance) {
          this._clearFocusinHandlers();

          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.grid);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
          this.sliderInstance.init();

          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
          focusableElements.forEach((element) => {
            const handler = () => {
              const slide = element.closest('.swiper-slide');
              if (slide && this.sliderInstance?.slider) {
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            };
            element.addEventListener('focusin', handler);
            this._focusinHandlers.push({ element, handler });
          });
        }

        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          if (this._onBlockSelect) {
            document.removeEventListener('shopify:block:select', this._onBlockSelect);
          }
          this._onBlockSelect = (e) => {
            if (e.detail.sectionId !== this.sectionId) return;
            const index = Number(e.target?.dataset?.index);
            if (!Number.isNaN(index)) {
              this.sliderInstance.slider.slideToLoop?.(index) ?? this.sliderInstance.slider.slideTo?.(index);
            }
          };
          document.addEventListener('shopify:block:select', this._onBlockSelect);
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        if (this.sliderWrapper) {
          this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
          this.sliderWrapper.classList.add(this.classes.grid);
        }
        if (this.sliderInstance) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
  );
}
